<template>
  <nuxt-link
    v-if="path"
    :to="path"
    :style="style"
    :class="classes"
  >
    {{ text }}
  </nuxt-link>
  <a
    v-else-if="url"
    :href="url"
    target="_blank"
    :style="style"
    :class="classes"
  >
    {{ text }}
  </a>
  <a
    v-else
    :style="style"
    :class="classes"
    @click.stop.prevent="$emit('button-click')"
  >
    {{ text }}
  </a>
</template>

<script>
import MixinPrimaryColor from '~/mixins/primaryColor'
export default {
  mixins: [MixinPrimaryColor],
  props: {
    bold: Boolean,
    inverse: Boolean,
    disabled: Boolean,
    text: {
      type: String,
      required: true,
    },
    // internal path for nuxt-link element
    path: {
      type: String,
      default: undefined,
    },
    // url for native href
    url: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    classes () {
      return ['button', 'button-fidmarques', {
        'button-fidmarques--inverse': this.inverse,
        'button-fidmarques--bold': this.bold,
        'button-fidmarques--disabled': this.disabled,
      }]
    },
    style () {
      return this.inverse
        ? this.globalStylePrimaryColorText
        : this.globalStylePrimaryColorBackground
    },
  },
}
</script>

<style lang="scss" scoped>
.button {
  cursor: pointer;
}
.button-fidmarques {
  color: white;
  line-height: 5rem;
  padding: 1rem 3rem;
  border-radius: 2rem;
  text-transform: uppercase;
  text-decoration: none;
  box-shadow: 0 0.2rem 0.2rem rgba(0, 0, 0, 0.5);

  &:hover {
    color: white;
    box-shadow: 0 0 1rem black;
  }
  &:active {
    box-shadow: 0 0 0.2rem white inset;
  }
  &.button-fidmarques--disabled {
    opacity: 0.65;
    cursor: default;

    &:active, &:hover {
      box-shadow: none;
    }
  }
}
.button-fidmarques--inverse {
  background-color: white;

  &:hover {
    box-shadow: 0 0 1rem white;
  }
  &:active {
    box-shadow: 0 0 0.2rem black inset;
  }
  &.button-fidmarques--disabled {
    opacity: 1;
    background: #B8B8B8;
  }
}

.button-fidmarques--bold {
  font-weight: 800;
}
</style>
